import React from 'react';

export const Logo = () => (
    <div style={{ maxWidth: '32rem', padding: '1.75rem 1.25rem' }}>
        <img
            src={`${process.env.PUBLIC_URL}/images/ds-analyzer-vert-black-logo.svg`}
            alt="seal error"
        />
    </div>
);
